import ResourceTemporaryUser from './ResourceTemporaryUser.js'

export default class ResourceTemporaryUsers {
  constructor( connect, options ) {
    this.connect = connect.child( `${options.childPrefix}${options.divider ?? '/'}temporaryUser` )
  }

  temporaryUser( id ) {
    return new ResourceTemporaryUser( this.connect, id, { idOnly : true } )
  }

  create( body, opts ) {
    return this.connect.post( body, opts )
  }

  list( opts ) {
    return this.connect.get( opts )
  }

  get( id, opts ) {
    return this.temporaryUser( id ).get( opts )
  }

  delete( id, body, opts ) {
    return this.temporaryUser( id ).delete( body, opts )
  }

  update( id, body, opts ) { 
    return this.temporaryUser( id ).patch( body, opts )
  }

  renew( id, body, opts ) {
    return this.temporaryUser( id ).renew( body, opts )
  }

  revoke( id, body, opts ) {
    return this.temporaryUser( id ).revoke( body, opts )
  }

  share( id, body, opts ) {
    return this.temporaryUser( id ).share( body, opts )
  }
}
